import { useState, useEffect } from 'react'

// Reloj que avanza cada `intervalMs`. Los autos se mueven interpolando contra
// este valor, así que un tick por segundo alcanza para un movimiento fluido
// (un viaje de horas se desplaza sub-pixel por segundo).
const useNow = (intervalMs = 1000) => {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}

export default useNow
